import { Link } from "react-router-dom";
import { gossipEvents } from "@/mocks/events";
import { siteInfo } from "@/mocks/site";
import { formatHeat } from "@/lib/format";

export default function Hero() {
  const topThree = [...gossipEvents].sort((a, b) => b.heat - a.heat).slice(0, 3);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20background%20with%20deep%20charcoal%20and%20warm%20coral%20tones%2C%20stylized%20geometric%20shapes%20and%20layered%20paper%20cut%20texture%2C%20muted%20green%20accents%2C%20moody%20cinematic%20lighting%2C%20dark%20atmosphere%20with%20strong%20contrast%20suitable%20for%20white%20text%20overlay%2C%20modern%20magazine%20style%2C%20no%20text%2C%20no%20people&width=1800&height=1000&seq=gua-hero-01&orientation=landscape"
          alt="网报吃瓜事件库暖色调抽象背景"
          title="网报吃瓜 - 吃瓜事件库"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 pb-16 md:pt-40 md:pb-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-white/90 backdrop-blur-sm">
              <i className="ri-flashlight-line text-secondary-300" />
              今日已整理 {gossipEvents.length} 条事件串
            </span>

            <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
              网报吃瓜
              <span className="mt-2 block text-2xl text-white/85 md:text-3xl">打开就是吃瓜事件库</span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-white/80 md:text-base">{siteInfo.description}</p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/events"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-list-check-2" />
                浏览吃瓜事件库
              </Link>
              <a
                href="#hot-radar"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20 whitespace-nowrap"
              >
                <i className="ri-fire-line text-secondary-300" />
                看今天在追什么
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-white/15 pt-6 max-w-lg">
              {[
                { value: "1,240+", label: "事件串" },
                { value: "6", label: "分类方向" },
                { value: "每日", label: "整理更新" },
              ].map((item) => (
                <div key={item.label}>
                  <dt className="font-heading text-xl font-bold text-white md:text-2xl">{item.value}</dt>
                  <dd className="mt-1 text-xs text-white/70">{item.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="lg:col-span-5 lg:pl-4">
            <div className="rounded-lg border border-white/15 bg-black/35 p-5 backdrop-blur-md md:p-6">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-white">
                  <i className="ri-radar-line text-secondary-300" />
                  此刻热度前三
                </h2>
                <span className="text-xs text-white/60">实时排序</span>
              </div>

              <ul className="mt-5 flex flex-col gap-3">
                {topThree.map((event, index) => (
                  <li key={event.id}>
                    <Link
                      to={`/events/${event.id}`}
                      className="group flex items-center gap-4 rounded-lg border border-white/10 bg-white/5 p-3 transition-colors hover:bg-white/15"
                    >
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50">
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-semibold text-white group-hover:text-secondary-200">
                          {event.title}
                        </span>
                        <span className="mt-0.5 flex items-center gap-2 text-xs text-white/60">
                          <i className="ri-fire-line text-primary-300" />
                          {formatHeat(event.heat)}
                          <span>·</span>
                          {event.category}
                        </span>
                      </span>
                      <i className="ri-arrow-right-s-line text-white/50 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </li>
                ))}
              </ul>

              <p className="mt-5 text-xs leading-relaxed text-white/55">
                热度为站内相对参考值，按话题密度与持续天数综合排序，仅用于帮助筛选。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}